import React, {Component} from "react";
import {connect} from 'react-redux';
import {Divider, IconButton, Stack, Tooltip} from '@mui/material';
import HeadBarSettings from "./headbar_apps/DisplaySetting";
import {MorphleLogoBW, MorphleLogoSquare, responsiveLayers} from "../../utils/const";
import '../../asset/style/gammaviewer/header_gammaViewer.css'
import SplitSync from "./headbar_apps/SplitSync";
import Screenshot from "./headbar_apps/Screenshot";
import OneToOnePDF from "./headbar_apps/OneToOnePDF";
import ShareLink from "./headbar_apps/ShareLink";
import SlideName from "./headbar_apps/SlideName";
import {changeGammaViewUrl, debounce, isNull, isSuperuser, notNull} from "../../utils/utils";
import CaseImage from "./headbar_apps/CaseImage";
import {checkAppPermission} from "./utils/gammaScanUtils";
import {isOpenLayersMap} from "./utils/map_utils";
import {
    caseInfoApp,
    editAnnoLabelApp,
    goToPrevNextSlideApp,
    gridOverlayApp,
    metsApp,
    oneToOnePdfApp,
    screenshotApp,
    shareLinkApp,
    shareSlideApp,
    splitSyncApp,
    tileViewApp
} from "./app_maker";
import GridOverlay from "./headbar_apps/GridOverlay";
import SwitchToTileView from "./headbar_apps/SwitchToTileView";
import DrawTools from "./drawTools/DrawTools";
import DrawToolsOSD from "./openseadragon/annotations/DrawToolsOSD";
import {FEATURE_MODES, getFeatureMode} from "./openseadragon/featureRegistry";
import AddToLnmet from "./headbar_apps/AddToLnmet";
import ImageLoadProgress from './headbar_apps/ImageLoadProgress';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Button from '@mui/material/Button';
import {getAdjacentSlides} from "../../redux_actions/slides.action";
import {KeyboardDoubleArrowLeftTwoTone, KeyboardDoubleArrowRightTwoTone} from "@mui/icons-material";
import {morphleBaseTheme1} from "./themes";
import EditAnnoLabel from "./headbar_apps/EditAnnoLabel";
import {openDefaultEndpoint} from "utils/endpoint_utils";
import {aclPermissions, hasPermissions} from "../../const/ACLPermissions";
import {changeDisplayedSlide} from "../../redux_actions/maps.state.action";
import {withRouter} from "react-router-dom";
import {clearAllSlidesFromSplitSyncView} from "../../redux_actions/splitSyncSlides.action";
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import {addSlidesToShare} from "../../redux_actions/shareManager.action";

class HeadBar extends Component {

    constructor(props) {
        super(props);

        this.state = {anchorEl: null, prevSlide: null, nextSlide: null}
        this.hasAnnotationCreatePermission = hasPermissions([aclPermissions.create_annotation]);
        this.is_superuser = isSuperuser()
    }

    handleClose = () => {
        this.setState({anchorEl: null});
    };


    componentDidMount = () => {
        if (this.props.slide !== undefined) {
            this.props.dispatch(getAdjacentSlides(this.props.slide.id, (result) => {
                this.setState({prevSlide: result["prev_slide"], nextSlide: result["next_slide"]});
            }));
        }
        document.addEventListener('mousedown', this.handleOutsideClick);

        this.debounceFunc = debounce(this.resizeListener, 400)
        window.addEventListener("resize", this.debounceFunc);

        this.isMobile = document.documentElement.clientWidth <= responsiveLayers.MOBILE_WIDTH_LEVEL &&
            (document.documentElement.clientWidth < document.documentElement.clientHeight);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ((isNull(prevProps.slide) && notNull(this.props.slide)) || prevProps.slide?.id !== this.props.slide?.id) {
            this.props.dispatch(getAdjacentSlides(this.props.slide.id, (result) => {
                this.setState({prevSlide: result["prev_slide"], nextSlide: result["next_slide"]});
            }));
        }
    }

    componentWillUnmount = () => {
        document.removeEventListener('mousedown', this.handleOutsideClick);
        window.removeEventListener("resize", this.debounceFunc);
    };
    resizeListener = () => {
        this.forceUpdate();
        this.isMobile = document.documentElement.clientWidth <= responsiveLayers.MOBILE_WIDTH_LEVEL &&
            (document.documentElement.clientWidth < document.documentElement.clientHeight);
    }

    handleOutsideClick = (event) => {
        const dropdownButton = document.getElementById('custom-dropdown');
        if (dropdownButton && !dropdownButton.contains(event.target)) {
            this.handleClose();
        }
    };

    drawTools = () => {
        if (!this.hasAnnotationCreatePermission) return null;
        if (isOpenLayersMap(this.props.slidemap)) return <DrawTools/>;
        return getFeatureMode('annotations', this.props.osdViewerConfig) === FEATURE_MODES.HIDDEN ? null : <DrawToolsOSD/>;
    }

    // Grid and Edit Anno Label run their registry fallback on click; this only covers the `hidden` mode.
    hiddenOnOsd = (feature) => !isOpenLayersMap(this.props.slidemap)
        && getFeatureMode(feature, this.props.osdViewerConfig) === FEATURE_MODES.HIDDEN;

    topBarElements = (spacing) => {
        return <>
            <Stack spacing={spacing} justifyContent={"flex-start"} alignItems={"center"}
                   direction={"row"}
                   divider={<Divider orientation="vertical" flexItem/>}>
                {checkAppPermission(splitSyncApp) && <SplitSync/>}
                {checkAppPermission(gridOverlayApp) && !this.hiddenOnOsd('grid_overlay') && <GridOverlay/>}
                {checkAppPermission(screenshotApp) && <Screenshot/>}
                {checkAppPermission(caseInfoApp) && <CaseImage/>}
                {this.is_superuser && checkAppPermission(metsApp) && <AddToLnmet/>}
                {checkAppPermission(editAnnoLabelApp) && !this.hiddenOnOsd('edit_anno_label') && <EditAnnoLabel/>}
                {checkAppPermission(oneToOnePdfApp) && <OneToOnePDF/>}
                {this.is_superuser && checkAppPermission(tileViewApp) && <SwitchToTileView/>}
            </Stack>
        </>
    }

    shareSlideButton = () => {
        return <Tooltip title={"Share Slide"} placement={"bottom"} className="share-slide-to-others-forTour">
            <IconButton size="small" onClick={() => this.props.dispatch(addSlidesToShare(this.props.slide.id))}>
                <GroupAddOutlinedIcon sx={{color: morphleBaseTheme1.palette.headBarIcon.primary}}/>
            </IconButton>
        </Tooltip>
    }

    render() {

        const WIDTH_FIRST_BREAK_POINT = 1640;
        const WIDTH_SECOND_BREAK_POINT = 1120;
        const WIDTH_THIRD_BREAK_POINT = 650;

        let spacing = 1.5;
        if (document.documentElement.clientWidth < WIDTH_SECOND_BREAK_POINT) {
            spacing = 0.9;
        } else if (document.documentElement.clientWidth < WIDTH_THIRD_BREAK_POINT) {
            spacing = 0.5;
        }

        let prevSlideTitle = null, nextSlideTitle = null;
        if (notNull(this.state.prevSlide)) {
            prevSlideTitle = this.state.prevSlide.name;
        }
        if (notNull(this.state.nextSlide)) {
            nextSlideTitle = this.state.nextSlide.name;
        }

        let customNavButtonStyle = {padding: 0, margin: 0};
        let useCustomNavButtonStyle = false;
        // TODO: Define width in vars
        if (this.isMobile || document.documentElement.clientWidth < WIDTH_FIRST_BREAK_POINT) {
            // useCustomNavButtonStyle = true;
        }

        // if (!this.props.slidemap)
        //     return <LoadingText/>;

        let open = Boolean(this.state.anchorEl);

        return (
            <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} className={"full-width"}
                   height={this.props.headBarHeight} bgcolor={"background.paper"} position={"fixed"} zIndex={"1"}>
                <Stack spacing={spacing} justifyContent={"flex-start"} alignItems={"center"} direction={"row"}
                       divider={<Divider orientation="vertical" flexItem/>}>
                    <img src={document.documentElement.clientWidth > 1500 ? MorphleLogoBW : MorphleLogoSquare}
                         className={"morphle-header-logo"} alt={"MorphleBWLogo"}
                         onClick={(event) => openDefaultEndpoint(event.ctrlKey)}
                         style={document.documentElement.clientWidth > 1500 ? {cursor: 'pointer', paddingLeft: 10} :
                             {
                                 cursor: 'pointer',
                                 height: '30px',
                                 width: '28px',
                                 marginLeft: '10px',
                                 marginRight: '-4px'
                             }}
                    />
                    {notNull(this.props.slidemap) && <>
                    {document.documentElement.clientWidth > WIDTH_THIRD_BREAK_POINT ? <HeadBarSettings/> : null}
                    {document.documentElement.clientWidth > WIDTH_SECOND_BREAK_POINT ? this.drawTools() : null}
                    {document.documentElement.clientWidth > WIDTH_FIRST_BREAK_POINT ? this.topBarElements(spacing) : null}

                    {!this.isMobile && document.documentElement.clientWidth < WIDTH_FIRST_BREAK_POINT ?
                        <Stack sx={{width: '30px'}}>
                            <Tooltip title={"Click to open more Tools"} placement={"bottom"}>
                                <Button id="drop-down" color={'secondary'}
                                        sx={{marginLeft: -2}}
                                        onClick={() => this.setState((prevState) => ({anchorEl: !prevState.anchorEl}))}>
                                    {open ? <ExpandLessIcon sx={{backgroundColor: 'black', borderRadius: '50px'}}/> :
                                        <ExpandMoreIcon/>}
                                </Button>
                            </Tooltip>
                            <div id="custom-dropdown" className={'dropdown-menu'}
                                 style={{visibility: open ? 'visible' : 'hidden'}}>
                                {this.topBarElements(spacing)}
                                {document.documentElement.clientWidth < WIDTH_SECOND_BREAK_POINT ? this.drawTools() : null}
                                {document.documentElement.clientWidth < WIDTH_THIRD_BREAK_POINT && !this.isMobile ?
                                    <Stack spacing={spacing} justifyContent={"flex-start"} alignItems={"center"}
                                           direction={"row"} divider={<Divider orientation="vertical" flexItem/>}>
                                        {checkAppPermission(shareSlideApp) && this.shareSlideButton()}
                                        {checkAppPermission(shareLinkApp) && <ShareLink/>}
                                        <HeadBarSettings/>
                                    </Stack> : null}
                            </div>
                        </Stack> : null}

                    {checkAppPermission(goToPrevNextSlideApp) && <React.Fragment>
                        <Tooltip
                            title={prevSlideTitle === null ? "No Prev Slide" : "Go to prev slide: " + prevSlideTitle}
                            placement={"bottom"} className='go-to-prev-forTour'>
                            <IconButton style={useCustomNavButtonStyle ? customNavButtonStyle : {}}
                                        disabled={prevSlideTitle === null} size="small"
                                        onClick={() => {
                                            changeGammaViewUrl(this.props, this.props.slide.id, this.state.prevSlide.id)
                                            this.props.dispatch(clearAllSlidesFromSplitSyncView())
                                            this.props.dispatch(changeDisplayedSlide(this.state.prevSlide));
                                        }}>
                                <KeyboardDoubleArrowLeftTwoTone style={{
                                    color: prevSlideTitle === null ?
                                        morphleBaseTheme1.palette.headBarIcon.grey : morphleBaseTheme1.palette.headBarIcon.primary
                                }}/>
                            </IconButton>
                        </Tooltip>

                        <Tooltip
                            title={nextSlideTitle === null ? "No Next Slide" : "Go to next slide: " + nextSlideTitle}
                            placement={"bottom"} className='go-to-next-forTour'>
                            <IconButton style={useCustomNavButtonStyle ? customNavButtonStyle : {}}
                                        disabled={nextSlideTitle === null} size="small"
                                        onClick={() => {
                                            changeGammaViewUrl(this.props, this.props.slide.id, this.state.nextSlide.id)
                                            this.props.dispatch(clearAllSlidesFromSplitSyncView());
                                            this.props.dispatch(changeDisplayedSlide(this.state.nextSlide));
                                        }}>
                                <KeyboardDoubleArrowRightTwoTone style={{
                                    color: nextSlideTitle === null ?
                                        morphleBaseTheme1.palette.headBarIcon.grey : morphleBaseTheme1.palette.headBarIcon.primary
                                }}/>
                            </IconButton>
                        </Tooltip>
                    </React.Fragment>}

                    <ImageLoadProgress/>
                    </>}
                </Stack>
                {notNull(this.props.slidemap) && <Stack spacing={spacing / 2} alignItems="center"
                       direction={"row"} justifyContent="flex-end"
                       divider={<Divider orientation="vertical" flexItem/>}>
                    {this.props.slideNameVisible ?
                        <SlideName prevSlide={this.state.prevSlide} nextSlide={this.state.nextSlide}
                                   mapId={this.props.activeMapId} slide={this.props.slide}/> : null}
                    {!this.isMobile && checkAppPermission(shareSlideApp) &&
                        document.documentElement.clientWidth > WIDTH_THIRD_BREAK_POINT ? this.shareSlideButton() : null}
                    {!this.isMobile && checkAppPermission(shareLinkApp) &&
                        document.documentElement.clientWidth > WIDTH_THIRD_BREAK_POINT ? <ShareLink/> : null}
                    {this.isMobile && checkAppPermission(shareLinkApp) ? <ShareLink/> : null}
                    {/*<Profile/>*/}
                </Stack>}
            </Stack>
        );
    }
}

const mapStateToProps = (state) => {
    let {activeMapId} = state.gammaStateReducer;
    let mapsState = state.mapsStateReducer;
    let slideNameVisible = Object.keys(mapsState).length >= 1;
    let {slide, slidemap} = mapsState[activeMapId] || {};
    return {activeMapId, slide, slidemap, slideNameVisible, osdViewerConfig: state.osdViewerConfigReducer};
};


export default connect(mapStateToProps)(withRouter(HeadBar));
